var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasterBoxIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.57227V17.4111C0.5 18.8696 1.28068 19.1853 1.28068 19.1853L9.54744 25.6842C10.8488 26.7071 10.4995 24.5536 10.4995 24.5536V16.429L0.5 8.57227Z",
    fill: "#662113"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 8.57227V17.4111C20.5001 18.8696 19.7409 19.1853 19.7409 19.1853C19.7409 19.1853 12.7647 24.6614 11.4641 25.6842C10.162 26.7071 10.5006 24.5536 10.5006 24.5536V16.429L20.5001 8.57227Z",
    fill: "#C1694F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4206 1.07482C10.8827 0.639124 10.0006 0.639124 9.46209 1.07482L0.90391 7.8809C0.365363 8.31659 0.365363 9.0287 0.90391 9.46367L9.49137 16.3533C10.0299 16.7883 10.912 16.7883 11.4506 16.3533L20.0959 9.40368C20.6344 8.9687 20.6344 8.25659 20.0959 7.8209L11.4206 1.07482Z",
    fill: "#D99E82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4955 26.2515C10.1012 26.2515 9.78125 25.9073 9.78125 25.4816V16.2485C9.78125 15.8228 10.1012 15.4785 10.4955 15.4785C10.8905 15.4785 11.2098 15.8228 11.2098 16.2485V25.4816C11.2098 25.9073 10.8905 26.2515 10.4955 26.2515Z",
    fill: "#D99E82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6379 14.1694C17.6379 14.958 17.7121 15.3451 16.9236 15.9136L15.1601 17.255C14.3716 17.8243 14.0666 17.3357 14.0666 16.5465V14.4316C14.0666 14.2937 14.048 14.1459 13.868 13.9973C12.0267 12.4795 4.87702 6.80053 3.57422 5.75201L6.87764 3.125C7.78188 3.78639 14.558 9.01898 17.3929 11.251C17.5336 11.3624 17.6379 11.4853 17.6379 11.6196V14.1694Z",
    fill: "#99AAB5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3922 11.251C14.558 9.01899 7.78188 3.78639 6.87764 3.125L5.64841 4.10209L3.57422 5.75201C4.87773 6.80053 12.0267 12.4795 13.868 13.9973C13.9759 14.0866 14.023 14.1759 14.0452 14.2623L17.5686 11.4296C17.5257 11.3674 17.4643 11.3074 17.3922 11.251Z",
    fill: "#CCD6DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6432 14.1694V11.6196C17.6432 11.4853 17.5389 11.3632 17.3975 11.251C14.5633 9.01899 7.78723 3.78639 6.88299 3.125L5.40234 4.3028C7.8258 6.20913 14.3169 11.2174 16.0161 12.5688C16.199 12.7145 16.2147 12.8652 16.2147 13.0031V16.4572L16.929 15.9136C17.7175 15.3444 17.6432 14.958 17.6432 14.1694Z",
    fill: "#CCD6DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3975 11.251C14.5633 9.01899 7.78723 3.78639 6.88299 3.125L5.40234 4.3028C7.8258 6.20913 14.3169 11.2174 16.0161 12.5688C16.0426 12.5895 16.059 12.6109 16.0783 12.6317L17.5739 11.4296C17.5311 11.3674 17.4696 11.3074 17.3975 11.251Z",
    fill: "#E1E8ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasterBoxIcon);
export default __webpack_public_path__ + "static/media/EasterBoxIcon.cd8b5a6416253ab36d1ff1419b61a6b1.svg";
export { ForwardRef as ReactComponent };